export default {
  placeholder: 'Wybierz poziomy ważności',
};
